export const businessFrontListSelector = state => state.businessFronts.businessFrontList
